import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import PublicSite from './pages/PublicSite';
import StartSong from './pages/StartSong';
import Pricing from './pages/Pricing';
import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import Studio from './pages/Studio';
import PaymentResult from './pages/PaymentResult';
import SongShare from './pages/SongShare';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicSite />} />
              <Route path="/start" element={<StartSong />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/signin" element={<Auth />} />
              <Route path="/signup" element={<Auth />} />
              <Route path="/studio/signin" element={<Auth />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/payment/success" element={<PaymentResult />} />
              <Route path="/payment/cancel" element={<PaymentResult />} />
              <Route path="/song/:code" element={<SongShare />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: '#141009', border: '1px solid rgba(224,183,85,0.25)', color: '#F6EDDD' } }} />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
